import { useCallback } from 'react';
import { useNavigate, type NavigateOptions, type To } from 'react-router-dom';

/**
 * navigate() that opts the navigation into React Router's View Transition — the
 * cross-page SLIDE. Use it for every FORWARD navigation that should slide (opening
 * a detail from a list / card / related-item especially). Opting a forward leg in
 * is also what lets a later NATIVE browser Back to that page animate: React Router
 * records the opted-in path pair and replays the transition on the POP. The slide
 * direction (html[data-vt-dir]) and scroll restoration are handled centrally by
 * <SlideDirectionBridge>, so callers just navigate.
 *
 * Going BACK/closing does NOT use this — call the raw navigate(-1); the resulting
 * POP replays the recorded transition automatically.
 */
export function useSlideNavigate() {
  const navigate = useNavigate();
  return useCallback(
    (to: To, opts?: NavigateOptions) => navigate(to, { ...opts, viewTransition: true }),
    [navigate],
  );
}
